import React from "react";
import { LabelledMultiSelect } from "@coverme/forms";
import { first } from "lodash-es";

const getOptions = options => {
    if (options.length === 0) {
        return [];
    }

    const isKeyValuePair = first(options).label != null;
    let newOptions = [];
    if (isKeyValuePair) {
        newOptions = options;
    } else {
        newOptions = options.map(x => ({ label: x, value: x }));
    }

    return newOptions;
};

export const SimpleMultiSelect = ({
    name,
    id,
    errors,
    touched,
    setFieldValue,
    value,
    options,
    title,
    placeholder,
    onChange,
    setFieldTouched,
    validState,
    errorMessage,
    disabled,
    ...props
}) => {
    let newOptions = getOptions(options);
    const selectedValues = first(newOptions.filter(x => x.value === value));
    return (
        <LabelledMultiSelect
            {...props}
            title={title}
            label={title}
            placeholder={placeholder}
            value={selectedValues}
            id={id}
            onChange={e => {
                const selectedValues = e.map(x => {
                    if (x.value) {
                        return x.value;
                    } else {
                        return x;
                    }
                });
                setFieldValue(name, selectedValues);
            }}
            options={newOptions}
            validState={validState}
            errorMessage={errorMessage}
            onBlur={() => setFieldTouched(name)}
            isDisabled={disabled}
        />
    );
};
